import { Button as UIButton, CircularProgress } from "@mui/material";
import Saveicon from "@mui/icons-material/SaveOutlined";
import isEmpty from "lodash/isEmpty";
import { useStyles } from "../styles/ActionButtonBar.styles";
import { Button } from "$components";
import { useEDBFormContext } from "../context/EDBFormContext";
import { STEP } from "../types/edb.types";
import useEDBFormHandlers from "../hooks/useEDBFormHandlers";
import { useMaterialNeed } from "../hooks/useMaterialNeed";

function ActionButtonBar() {
  const classes = useStyles();
  const { onCancel, handleNextStep, onSubmit, isSubmitting } =
    useEDBFormHandlers();
  const {
    errors,
    step,
    maxStepIndex,
    showCart,
    currentProject,
    currentDockyard,
  } = useEDBFormContext();
  const { getTotalArticle } = useMaterialNeed();

  const isIdentificationMissing = !currentProject || !currentDockyard;

  return (
    <div
      className={
        step !== STEP.FIRST_STEP
          ? classes.navigationStep
          : classes.firstNavigationStep
      }
    >
      {step !== STEP.FIRST_STEP && (
        <UIButton
          variant="outlined"
          style={{ textTransform: "none" }}
          onClick={onCancel}
          disabled={isSubmitting}
          className={isSubmitting ? classes.disabledNavButton : ""}
        >
          Précédent
        </UIButton>
      )}
      <div>
        {step === STEP.PRODUCT_STEP && showCart && (
          <Button
            variant="outlined"
            color="primary"
            style={{ textTransform: "none", marginRight: 20 }}
            onClick={() => onSubmit(true)}
            disabled={getTotalArticle() < 1 || isSubmitting}
            className={`${classes.textButton} ${
              isSubmitting ? classes.loadingButton : ""
            }`}
          >
            <div className={classes.buttonContent}>
              {isSubmitting ? (
                <CircularProgress
                  size={16}
                  className={classes.spinner}
                  color="inherit"
                />
              ) : (
                <Saveicon style={{ marginRight: 8 }} />
              )}
              {isSubmitting ? "Enregistrement..." : "Réserver"}
            </div>
          </Button>
        )}
        <Button
          disabled={
            (step === maxStepIndex && step !== STEP.LAST_STEP) ||
            (step === STEP.LAST_STEP && isIdentificationMissing) ||
            !isEmpty(errors) ||
            isSubmitting
          }
          onClick={handleNextStep}
          className={isSubmitting ? classes.disabledPrimaryButton : ""}
        >
          <div className={classes.buttonContent}>
            {isSubmitting && step === STEP.LAST_STEP && (
              <CircularProgress
                size={16}
                className={classes.spinner}
                color="inherit"
              />
            )}
            {step === STEP.LAST_STEP
              ? isSubmitting
                ? "Enregistrement..."
                : "Demander l'approbation"
              : showCart
              ? "Lancer la préparation"
              : "Continuer"}
          </div>
        </Button>
      </div>
    </div>
  );
}

export default ActionButtonBar;
